module.exports = __webpack_public_path__ + "img/u8.92ad5867.png";